/* eslint-disable @typescript-eslint/no-explicit-any */
import * as types from "../actionTypes/transferActionTypes";

export const getTransferSearchAction = {
  STARTED: (args: any) => ({
    type: types.GET_TRANSFER_SEARCH.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_TRANSFER_SEARCH.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_TRANSFER_SEARCH.REJECTED }),
};

export const getTransferListAction = {
  STARTED: (args: any) => ({
    type: types.GET_TRANSFER_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_TRANSFER_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_TRANSFER_LIST.REJECTED }),
};

export const getSelectedTransfersAction = (value: {
  departure: any | null;
  return: any | null;
}) => {
  return {
    type: types.SET_SELECTED_TRANSFER,
    payload: value,
  };
};

export const resetSelectedTransfersAction = () => {
  return {
    type: types.RESET_SELECTED_TRANSFER,
    payload: {},
  };
};

export const getTransferPrebookAction = {
  STARTED: (args: any) => ({
    type: types.GET_TRANSFER_PREBOOK.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_TRANSFER_PREBOOK.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_TRANSFER_PREBOOK.REJECTED }),
};

export const getTransferCheckoutAction = {
  STARTED: (args: any) => ({
    type: types.GET_TRANSFER_CHECKOUT.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_TRANSFER_CHECKOUT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_TRANSFER_CHECKOUT.REJECTED }),
};
